import { PageComponent } from "./PageComponent";

export const PaymentPolicy = () => {
  var Page = {};
  Page.page = "Payment Policy";
  Page.heading = "Payment WES";
  Page.title = "INFORMATION";
  Page.bodyContent = [
    {
      title: "WES Components is an importer/distributor of electronic Accessories and Components.",
      content: (
        <p>
          We are the dedicated suppliers of electronics accessories and spare parts to the technicians, installers and
          engineers. Trade prices are applicable only to the registered customers only.
        </p>
      ),
    },
    {
      title: "WES Components also supplies a large range of electronic accessories.",
      content: (
        <p>
          This is a vast expanding area, growing to accommodate the ever changing requests of our customers and
          maintaining high quality standards with a price winning structure.
        </p>
      ),
    },
  ];

  return <PageComponent Data={Page} />;
};
